module.exports = __webpack_public_path__ + "static/media/loading.1cb6698c.gif";